import { CircularProgress, Grid, Stack } from '@vapor/material'
import { useMemo } from 'react'
import { ProductFragment, ProductsQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'
import PosProductCard from './pos-product-card'

type PosProductsProps = {
  productsResult: ProductsQuery | undefined
  onProductSelected: (product: ProductFragment) => void
  loading: boolean
}

export default function PosProducts(props: PosProductsProps) {
  const { productsResult, onProductSelected, loading } = props
  const { currency } = useTenant()

  const numberOfProducts: number = useMemo(() => {
    return productsResult?.products?.filter((product) => product.auditable.state === 'ACTIVE')?.length ?? loading ? 1 : 0
  }, [productsResult?.products?.length])

  return (
    <>
      {numberOfProducts > 0 && (
        <Grid container spacing={1}>
          {productsResult?.products
            ?.filter((product) => product.auditable.state === 'ACTIVE')
            ?.map((product) => {
              return (
                <Grid item xs={4} sm={4} md={4} lg={3} key={product.id} sx={{ height: 'auto' }}>
                  <PosProductCard disabled={loading} name={product.description} price={product.amount} currency={currency} onClick={() => onProductSelected(product)} />
                </Grid>
              )
            })}
        </Grid>
      )}
      {loading && (
        <Stack direction="row" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      )}
    </>
  )
}
